<script setup>
import { computed, ref } from "vue";
import { mdiClose } from "@mdi/js";
import BaseButton from "@/Components/BaseButton.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import CardBox from "@/Components/CardBox.vue";
import OverlayLayer from "@/Components/OverlayLayer.vue";
import CardBoxComponentTitle from "@/Components/CardBoxComponentTitle.vue";
import { isIntegerKey } from "@vue/shared";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  button: {
    type: String,
    default: "info",
  },
  buttonLabel: {
    type: String,
    default: "Aceptar",
  },
  hasCancel: Boolean,
  noButtons: Boolean,
  modelValue: {
    type: [String, Number, Boolean],
    default: null,
  },
  sizeModal: {
    type: String,
    default: "",
  }
});

// LRR
/* const resultConfirm = ref(false);
const clasModal = ref('shadow-lg max-h-modal w-11/12 md:w-3/5 lg:w-2/5 xl:w-4/12 z-50')
if (props.sizeModal == 'full') {
  clasModal.value = 'shadow-lg max-h-modal min-w-[100%] z-50'
} else if (props.sizeModal == 'big') {
  clasModal.value = 'shadow-lg min-h-[90%] min-w-[90%] z-50'
} */



// Tamaños de modal
const clasModal = ref('shadow-lg max-h-modal w-11/12 md:w-3/5 lg:w-2/5 xl:w-4/12 z-50')
if (props.sizeModal == 'small') {
    clasModal.value = 'shadow-lg z-50'
} else if (props.sizeModal == 'full') {// <-- para vista previa
    clasModal.value = 'shadow-lg container min-h-[90vh] z-50'
}else if (props.sizeModal == 'formfull') {// <-- para vista previa
    clasModal.value = 'shadow-lg z-50'
} else if (props.sizeModal == 'ajuste') {// <-- ajuste de margen por defecto según la pantalla
    clasModal.value = 'shadow-lg container mx-auto z-50'
} else if (props.sizeModal == 'medium') {
    clasModal.value = 'shadow-lg min-h-[90vh] z-50 w-full sm:w-11/12 lg:w-4/5 xl:w-9/12'
}

const emit = defineEmits(["update:modelValue", "cancel", "confirm"]);

const value = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const confirmCancel = (mode) => {
  value.value = false;// LRR creo que cierra el modal CardBoxmodal
  emit(mode);
  
  // LRR
  //if (mode == "confirm") {
    //resultConfirm.value = true
  //}
  //console.log(emit(mode))
  
};

const confirm = () => confirmCancel("confirm");

const cancel = () => confirmCancel("cancel");

window.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && value.value) {
    cancel();
  }
});

</script>

<template>
  <OverlayLayer v-show="value" @overlay-click="cancel">
    <CardBox
      v-show="value"
      :class="clasModal"
      is-modal
    >
      <CardBoxComponentTitle :title="title">
        <BaseButton
          v-if="hasCancel"
          :icon="mdiClose"
          color="whiteDark"
          small
          rounded-full
          @click.prevent="cancel"
        />
      </CardBoxComponentTitle>

      <div class="space-y-3">
        <slot />
      </div>

      <template v-if="!noButtons && sizeModal!='full' && sizeModal!='formfull'" #footer>
        <BaseButtons>
          <BaseButton :label="buttonLabel" :color="button" @click="confirm" />
          <BaseButton
            v-if="hasCancel"
            label="Cancel"
            :color="button"
            outline
            @click="cancel"
          />
        </BaseButtons>
      </template>
    </CardBox>
  </OverlayLayer>
</template>
